import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadOfferDetails } from '../../features/offerSearch/offerSearchSlice';
import { RootState } from '../../redux/rootReducer';
import { LOC } from '../../util/strings';
import { isValidLoc, LOC_TEXT_BOX_MAX_LENGTH } from '../../util/validation';
import withLocalization from '../hoc/withLocalization';
import './ViewDestination.scss';

const AlternateLOCInput: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const dispatch = useDispatch();
  const alternateLOCFromStore = useSelector((state: RootState) => state.offerDetails.alternateLOC);
  const alternateLOCDescription = useSelector((state: RootState) => state.offerDetails.alternateLOCDescription);
  const customerExcludedState = useSelector((state: RootState) => state.offerDetails.customerExcludedStateCode);
  const customerSelectedState = useSelector((state: RootState) => state.offerDetails.customerSelectedStateCode);
  const [alternateLOC, setalternateLOC] = useState(alternateLOCFromStore ? alternateLOCFromStore : '');
  const alternateLOCInputValue = alternateLOC ? alternateLOC : alternateLOCFromStore;
  const [locHasError, setLocHasError] = useState(false);
  const [buttonEnabled, setButtonEnabled] = useState(false);

  useEffect(() => {
    if (alternateLOCInputValue) {
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onLOCInputChange = (evt) => {
    setalternateLOC(evt.target.value);
    const loc = evt.target.value;
    if (!isValidLoc(loc)) {
      setLocHasError(true);
      setButtonEnabled(false);
    } else {
      setLocHasError(false);
      setButtonEnabled(true);
    }
  };
  const onChangeLOCClicked = (e) => {
    if (alternateLOC)
      dispatch(loadOfferDetails(alternateLOC.toUpperCase(), LOC, 'y', customerExcludedState, customerSelectedState));
  };
  return (
    <div className="alternateLOC_container">
      <div className="row alternate-loc-row">
        <div className="alternateLOC_leftHalf">
          <h6 className="loc_text">
            {localize('preview-sales-engine.static-content.copy.Labels.labels#alternate-loc')}
          </h6>
          <input
            className="input_box"
            type="text"
            defaultValue={alternateLOCInputValue}
            onChange={onLOCInputChange}
            maxLength={LOC_TEXT_BOX_MAX_LENGTH}
            autoComplete={'off'}
            list={'autocompleteOff'}
          />

          {buttonEnabled ? (
            <Button className="alternateLOC_button" onClick={onChangeLOCClicked}>
              {localize('preview-sales-engine.static-content.copy.Labels.labels#search-offers')}
            </Button>
          ) : (
            <Button className="alternateLOC_button" disabled>
              {localize('preview-sales-engine.static-content.copy.Labels.labels#search-offers')}
            </Button>
          )}
        </div>
        <div className="alternateLOC_rightHalf">
          <span className="loc_description">{alternateLOCDescription}</span>
        </div>
      </div>
      {locHasError ? (
        <span
          className="error"
          style={{
            marginLeft: '150px',
          }}
        >
          {localize('preview-sales-engine.static-content.copy.associate-search-page.loc-field-errors#pattern')}
        </span>
      ) : (
        <></>
      )}
    </div>
  );
};
export default withLocalization(AlternateLOCInput);
